export default __webpack_public_path__ + "static/stairs_b.a4975a81794e935a8108e16f4ba696ed.svg";